import { useMediaQuery, Box } from "@mui/material";
import { theme } from "../styles/mui-theme";
import bgImage from "../assets/bgImage.webp";

export const GradientBgAtom = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <>
      <Box
        sx={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          width: "100%",
          height: "100%",
          position: "absolute",
          top: 0,
          left: 0,
          zIndex: 2,
        }}
      />
      <Box
        sx={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          width: "100%",
          minWidth: "100%",
          height: "100%",
          position: "absolute",
          top: 0,
          left: 0,
          zIndex: 4,
          opacity: 0.5,
        }}
      />
    </>
  );
};
